export default function({ $axios }) {
  $axios.defaults.timeout = 600000;
}